import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import LoaderBase from 'src/components/10-atoms/loaders/LoaderBase';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const NotesListLoading = ({ visibleCount = 3, ...columnProps }) => {
    const [{ styles, theme }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { spacing: theme.spacing.standard.sm, ...columnProps }, new Array(visibleCount).fill(0).map((_, i) => (React.createElement(LoaderBase, { style: styles.loaderBase, key: i })))));
};
const stylesGenerator = createThemedStyle(({}) => ({
    loaderBase: { height: 88 },
}));
export default NotesListLoading;
